module.exports = __webpack_public_path__ + "img/1.61cedf36.jpg";